import './FeedbackNav.scss'

import React from 'react'
import PropTypes from 'prop-types'
import { FEEDBACKTYPE_POSITIVE, FEEDBACKTYPE_NEGATIVE } from '../../constants/feedbackConstants'
import { Icon } from 'react-fa'

const FeedbackNav = props => {
  return (
    <div className='feedback-container'>
      <button className='cp-button feedback-button' onClick={() => { props.onFeedbackNavClick(FEEDBACKTYPE_POSITIVE) }}>
        <Icon name='thumbs-up' />
      </button>
      <button className='cp-button feedback-button dislike-button' onClick={() => { props.onFeedbackNavClick(FEEDBACKTYPE_NEGATIVE) }}>
        <Icon name='thumbs-down' />
      </button>
    </div>
  )
}

FeedbackNav.propTypes = {
  onFeedbackNavClick: PropTypes.func
}

export default FeedbackNav



// WEBPACK FOOTER //
// ./src/components/FeedbackNav/FeedbackNav.js